import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../../../Actions/UserManagementActions";
import UsermanagementConstants from "../../../../Constants/UsermanagementConstants";
import usermanagementStore from "../../../../Stores/UsermanagementStore";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import AddCostCenter from "./AddCostCenter";
import { useRef } from "react";
import ConfirmationPopUp from "../../../MessageBox/ConfirmationPopUp";
import commonUtils from "../../../../helpers/commonUtils";
import { useGlobalSpinnerActionsContext } from "../../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../../Context/LanguageContext";
import { useSelectedConfigActionContext } from "../../../../Context/GlobalContext";
import CommonSearchBar from "../../../ReusableComponent/CommonSearchBar";
import { customizeFilter } from "../../../FilterOptions/CustomizeFilter";
import CostCenterGroupAction from "../../../../Actions/CostCenterGroupAction";
import { Button } from "@mui/material";
import CustomDataGrid from "../../../ReusableComponent/DataGrid/CustomizeDataGrid";
import ImportComponent from "../../../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
const CostCenter = (props) => {
  const { deleteCostCenter } = props;
  const [costCenterList, setCostCenterList] = useState(null);
  const [resCostCenterList, setResCostCenterList] = useState([]);
  const [costCenterDetails, setCostCenterDetails] = useState("");
  const [plantId, setPlantId] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const prevPlantId = useRef("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const updateSelectedConfig = useSelectedConfigActionContext();
  const [sendplantId, setSendPlantId] = useState("");
  const columns = [
    { field: "werk", headerName: localization.plant, hideable: false, flex: 1 },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "kost", headerName: localization.costCenter, flex: 1 },
    { field: "group", headerName: localization.group, flex: 1 },
    // { field: "id", headerName: "ID" },
    // { field: "werkID", headerName: "werkId" },
    // { field: "kostGroupID", headerName: "kostGroupID" },
  ];
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importCostCen,
    subHeaderTitle: localization.importCostCenTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);

  const getPlantCostCenter = (plantId) => {
    if (plantId != 0) {
      UserManagementActions.getCostCentreByWerkId(plantId);
      setGlobalSpinner(true);
    }
  };

  const getPlants = () => {
    UserManagementActions.getPlantsByUserId();
  };

  //------------------------ Add or Update Cost center section Start ----------------------
  useEffect(() => {
    getPlants();
    CostCenterGroupAction.getCostCenterGroupList();
    function AddOrUpdateCostCenterSuccess() {
      const res = usermanagementStore.getCostCentreAddOrUpdateResult();
      toast.success(
        commonUtils.getIsEdit()
          ? localization.costCenterEditedSuccessfully
          : localization.costCenterAddedSuccessfully,
      );
      commonUtils.hideModalPopUp("addCostCenterModalClose");
      setGlobalSpinner(false);
      setPlantId(prevPlantId.current);
      getPlantCostCenter(prevPlantId.current);
    }

    function AddOrUpdateCostCenterFailure() {
      const res = usermanagementStore.getCostCentreAddOrUpdateResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_COST_CENTRE_SUCCESS,
      AddOrUpdateCostCenterSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADDORUPDATE_COST_CENTRE_FAILURE,
      AddOrUpdateCostCenterFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_COST_CENTRE_SUCCESS,
        AddOrUpdateCostCenterSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADDORUPDATE_COST_CENTRE_FAILURE,
        AddOrUpdateCostCenterFailure,
      );
    };
  }, []);

  //------------------------ Get Cost center section Start ----------------------

  //------------------------Cost center vai plant list section Start ----------------------
  useEffect(() => {
    prevPlantId.current = plantId;
    getPlantCostCenter(plantId);

    function getPlantCostCenterSuccess() {
      var res = usermanagementStore.getPlantCostCenter();

      if (res.length > 0) {
        const tableData = res.map((item) => ({
          id: item.id,
          kost: item.kost,
          werk: item.werk,
          werkID: item.werkID,
          kostGroupID: item.kostGroupID,
          group: item.group,
        }));
        setCostCenterList(tableData);
        setResCostCenterList(tableData);
      } else {
        setResCostCenterList([]);
        setCostCenterList([]);
      }
      updateSelectedConfig("cost center");
      setGlobalSpinner(false);
    }

    function getPlantCostCenterFailure() {
      updateSelectedConfig("cost center");
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_COST_CENTER_SUCCESS,
      getPlantCostCenterSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_COST_CENTER_FAILURE,
      getPlantCostCenterFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_COST_CENTER_SUCCESS,
        getPlantCostCenterSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_COST_CENTER_FAILURE,
        getPlantCostCenterFailure,
      );
    };
  }, [plantId]);
  //------------------------ Cost center vai plant list section end ----------------------
  //------------------------ Get plant section start ----------------------
  useEffect(() => {
    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();

      if (res.length > 0) {
        setPlantList(res);
        setPlantId(res[0].id);
      } else {
        setPlantList([]);
      }
    }

    function getPlantFailure() {}

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);
  //------------------------ Get plant section end ----------------------

  //------------------------Add cost center button start ----------------------
  const handleAdd = () => {
    setCostCenterDetails("");
    setSendPlantId(plantId);
  };

  function RenderAddCostCenter() {
    return (
      <>
        <Button
          variant="outlined"
          id="addCostCenterTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AddIcon />}
          data-toggle="modal"
          data-target="#addCostCenter"
        >
          {localization.add}
        </Button>
      </>
    );
  }
  //------------------------Add cost center button end ----------------------

  //------------------------Edit cost center button Start ----------------------
  const setCurrentCostCenterDetails = (row) => {
    setCostCenterDetails(row);
    setSendPlantId(plantId);
  };

  function RenderEditButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="editCostCenterTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineEdit />}
          data-toggle="modal"
          data-target="#addCostCenter"
        >
          {localization.toolTipEdit}
        </Button>
      </>
    );
  }
  //------------------------Edit cost center button end ----------------------

  //------------------------Delete cost center button start ----------------------

  useEffect(() => {
    function deleteCostCenterSuccess() {
      const res = usermanagementStore.getDeleteCostCenter();
      if (res.length === 0) {
        toast.success(localization.costCenterDeletedSuccessfully);
      } else {
        res.forEach((item) => toast.error(item));
      }
      setCostCenterList(null);
      getPlantCostCenter(prevPlantId.current);
    }

    function deleteCostCenterFailure() {
      const res = usermanagementStore.getDeleteCostCenter();
      toast.error(res);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_COST_CENTER_SUCCESS,
      deleteCostCenterSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.DELETE_COST_CENTER_FAILURE,
      deleteCostCenterFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_COST_CENTER_SUCCESS,
        deleteCostCenterSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.DELETE_COST_CENTER_FAILURE,
        deleteCostCenterFailure,
      );
    };
  }, []);

  function deleteCostCenterCallback(id) {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteCostCenterConfirmation);
    setCallbackData({
      costCenterID: id,
    });
    setEventType("DELETE_COST_CENTER");
  }

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed) {
      switch (eventType) {
        case "DELETE_COST_CENTER":
          setGlobalSpinner(true);
          UserManagementActions.deleteCostCenter(data.costCenterID, plantId);
          closePopUpCallback();
          break;
        default:
          break;
      }
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const handleDelete = (row) => {
    const _idList = [];
    if (Array.isArray(row)) {
      row.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(row.id);
    }
    deleteCostCenterCallback(_idList);
    commonUtils.hideModalPopUp("addCostCenterModalClose");
  };

  function RenderDeleteCostCenterButton(props) {
    const id = props.costCenterID;
    return (
      <>
        <Button
          variant="outlined"
          id="deleteCostCenterTest"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<AiOutlineDelete />}
        >
          {localization.delete}
        </Button>
      </>
    );
  }
  //------------------------Delete cost center button end ----------------------

  function onClosePopOVer() {
    setSendPlantId("");
  }

  function handleSearch(_enterText) {
    const res = customizeFilter(resCostCenterList, _enterText, [
      "werkID",
      "id",
    ]);
    setCostCenterList(res);
  }
  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  const operations = {
    RowOperationList: [
      {
        label: "Edit",
        component: <RenderEditButton />,
        onClick: setCurrentCostCenterDetails,
      },
      {
        label: "Delete",
        component: <RenderDeleteCostCenterButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      {
        label: "Add",
        component: <RenderAddCostCenter />,
        onClick: handleAdd,
      },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteCostCenterButton />,
        onClick: handleDelete,
      },
    ],
  };
  function handleImport(seletedFile) {
    setGlobalSpinner(true);
    const obj = {
      ImportType: "CostCenter",
      ImportFile: seletedFile,
      WerkId: prevPlantId.current,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      setPlantId(prevPlantId.current);
      getPlantCostCenter(prevPlantId.current);
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "CostCenter",
      UpdateTempalte: false,
      WerkId: prevPlantId.current,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => setCurrentCostCenterDetails(params.row)}
        data-toggle="modal"
        data-target="#addCostCenter"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }

  return (
    <>
      <div className="w-100 h-100" id="content">
        {costCenterList && (
          <CustomDataGrid
            Title={localization.orgSetting + " / " + localization.costCenter}
            renderParentComponent={
              <div className="form-group d-flex  align-items-center">
                <label htmlFor="plantList" className="mr-3">
                  {localization.plant}
                </label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.bezeichnung}
                      </option>
                    );
                  })}
                </select>
              </div>
            }
            columns={columns}
            rows={costCenterList}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["werk", "kost", "group"]}
            showCheckBox={true}
            gridTableHeight={"dataGridSmall"}
          />
        )}
      </div>
      <AddCostCenter
        costCenterDetails={costCenterDetails}
        plantList={plantList}
        selectedPlantId={sendplantId}
        onClosePopOVer={onClosePopOVer}
      />
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
      {openImport.isOpen && <ImportComponent data={openImport} />}
    </>
  );
};

export default CostCenter;
